import type React from 'react'
import { createContext, useContext } from 'react'

export interface AppConfig {
  clientId: string
  authority: string
  knownAuthorities?: string[]
  redirectUri: string
  apiScopes: string[]
}

export const AppConfigContext = createContext<AppConfig | null>(null)

export const useAppConfig = () => {
  const ctx = useContext(AppConfigContext)
  if (!ctx) {
    throw new Error('useAppConfig must be used within AppConfigProvider')
  }
  return ctx
}

export const AppConfigProvider: React.FC<{
  config: AppConfig
  children: React.ReactNode
}> = ({ config, children }) => (
  <AppConfigContext.Provider value={config}>{children}</AppConfigContext.Provider>
)
